module.exports = __webpack_public_path__ + "img/form.3d456df4.svg";